<template>
  <div>
    <span>{{ item.category }}</span>
    <br>
    <b>{{ item.title }}</b>
  </div>
</template>

<script>
export default {
  props: {
    item: { required: true },
    searchText: { required: true }
  }
}
</script>
